export const MultiSectionStyle = {
  baseStyle: {},
  variants: {
    wrapper: {
      summary: {
        mainwrapper: {
          width: '100%',
          // minHeight: '100px',
          padding: '16px',
          marginBottom: '8px',
          // display: 'flex',
          // flexDirection: ['column', null, 'row'],
          // justifyContent: 'space-between',
          // align: 'flex-start',
          border: '1px',
          borderColor: 'GRAY',
          borderRadius: '4px',
        },
        detailsDisplay: {
          display: 'flex',
          flexDirection: 'column',
          justify: 'flex-start',
          height: '100%',
        },
        subwrapper: {
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'row',
          paddingTop: ['8px', null, 0],
        },
        head: {
          fontSize: '18px',
          fontWeight: 700,
          textTransform: 'uppercase',
        },
        subhead: {
          fontSize: '18px',
          textTransform: 'capitalize',
        },
      },
      resumeSummary: {
        mainwrapper: {
          width: '100%',
          minHeight: '200px',
          padding: [0, null, '8px'],
          margin: '0px',
          display: 'flex',
          flexDirection: 'column',
          border: '1px',
          borderColor: 'GRAY',
          borderRadius: '4px',
          position:'relative',
        },
        detailsDateBox: {
          position:'absolute',
          bottom: '1rem',
          padding: '1rem 0 0 0',
          display: 'flex',
          flexGrow: 1,
          alignItems: 'flex-start',
          width:'fit-content',
          left: '0',
          right:'0',
          marginLeft: '1.5rem',
        },
        navBox: {
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-end',
        },
        detailsDisplay: {
            display: 'flex',
            justifyContent:'space-between',
            height: '100%',
          width:'90%',
          margin:'0 auto',
        },
        head: {
          color: 'NAVY',
          fontSize: '18px',
          fontWeight: 600,
          textTransform: 'uppercase',
          textDecoration: 'underline',
        },
        subhead: {
          marginTop:"3rem",
          marginRight:"-.8rem",
          bottom:"1.5rem",
          right:"1rem",
          fontSize: '18px',
          textTransform: 'capitalize',
        },
      },
    },
  },
};
